import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const NewReleasePage = () => {
  const { find, meta } = usePageContent('new-release');
  const seo = meta?.seo;
  useTitle(seo?.title || 'There are 47 million new ways to make it yours');
  useMeta(seo);
  const c = find('richText') || {};

  return (
    <div id="content">
      <div className="page-header">
        <div className={`content-holder content-holder--indented ${styles.holder} ${styles.headerHolder}`}>
          <h1 className="page-header__title">{c.pageTitle || 'New release'}</h1>
        </div>
      </div>
      <div className={`content-holder content-holder--indented ${styles.holder}`}>
        <div
          className={`rich-text ${styles.wrapper}`}
          dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }}
        />
      </div>
    </div>
  );
};

export default NewReleasePage;
